import React from "react";

const Avatar3 = ({ color = "#222", size = 100 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={size}
    height={size}
    viewBox="0 0 75 75"
    preserveAspectRatio="xMidYMid meet"
  >
    <defs>
      <filter id="filter0" width="100%" height="100%" x="0%" y="0%">
        <feColorMatrix
          colorInterpolationFilters="sRGB"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
        />
      </filter>
      <clipPath id="clip0">
        <path d="M4.27 4.27H71V71H4.27z" />
      </clipPath>
      <clipPath id="clip1">
        <path d="M26 23.72h22V44H26z" />
      </clipPath>
      <mask id="mask0">
        <g filter="url(#filter0)">
          <rect x="-7.5" y="-7.5" width="90" height="90" fill="#000" fillOpacity="0.2" />
        </g>
      </mask>
      <clipPath id="clip2">
        <path d="M1 0.2h21.28V5H1z" />
      </clipPath>
      <clipPath id="clip3">
        <rect x="0" y="0" width="23" height="5" />
      </clipPath>
      <mask id="mask1">
        <g filter="url(#filter0)">
          <rect x="-7.5" y="-7.5" width="90" height="90" fill="#000" fillOpacity="0.2" />
        </g>
      </mask>
      <clipPath id="clip4">
        <path d="M0.6 0.2h21.6V5H0.6z" />
      </clipPath>
      <clipPath id="clip5">
        <rect x="0" y="0" width="23" height="5" />
      </clipPath>
      <clipPath id="clip6">
        <path d="M12.04 42H63v9.47H12.04z" />
      </clipPath>
    </defs>

    {/* Main circle */}
    <g clipPath="url(#clip0)">
      <path
        fill={color}
        d="M37.5 70.72A33.26 33.26 0 0 1 4.27 37.5 33.26 33.26 0 0 1 37.5 4.27 33.26 33.26 0 0 1 70.72 37.5 33.26 33.26 0 0 1 37.5 70.72Zm0-64.66A31.47 31.47 0 0 0 6.06 37.5 31.47 31.47 0 0 0 37.5 68.94 31.47 31.47 0 0 0 68.94 37.5 31.47 31.47 0 0 0 37.5 6.06Zm0 0"
      />
    </g>

    {/* Face paths */}
    <path
      fill={color}
      d="M38.68 47.68a6.8 6.8 0 0 1 2.62-2.12c1.03-.46 2.1-.74 3.22-.84 1.25-.13 2.5-.08 3.75.05 1.4.14 2.8.4 4.2.6 1.1.16 2.21.25 3.33.29.92.04 1.85.05 2.77.04.22 0 .38.04.54.2l-.67-.95s-.05-.08-.19-.07l-.24-.02c-.96.05-1.9-.05-2.86-.16-1.45-.18-2.9-.47-4.33-.76a23.5 23.5 0 0 0-3.09-.45c-1.48-.1-2.96-.06-4.42.28-.76.18-1.5.44-2.18.82-.6.34-1.14.77-1.63 1.26-.45.46-.9.94-1.22 1.5-.07.13-.14.15-.26.13l.7.34c-.07-.04-.1-.07-.04-.14Zm-18.93-6.86c.23-.1.48-.14.71-.21.72-.22 1.36-.6 2-.98.6-.38 1.13-.83 1.68-1.25.5-.39 1.02-.77 1.63-1a5.28 5.28 0 0 1 2.8-.19c1.9.37 3.5 1.27 4.78 2.73.32.37.54.8.8 1.2l.03.09c-.07 0-.1-.04-.13-.06a8.93 8.93 0 0 0-3.6-1.63 11.9 11.9 0 0 0-3.07-.22c-1.41.1-2.76.46-4.1.88-.64.2-1.28.4-1.95.49-.52.07-1.04.17-1.58.15Zm0 0"
    />
    
    <path
      fill={color}
      d="M55.36 42.52a40.51 40.51 0 0 1-3.92-.75 26.33 26.33 0 0 0-3.53-.62 11.57 11.57 0 0 0-3.09.11c-.7.14-1.4.3-2.06.6a9.01 9.01 0 0 0-3.46 2.93l-.25.36a.65.65 0 0 0 .2-.14c.71-.64 1.47-1.21 2.33-1.65a10.6 10.6 0 0 1 3.65-1.03c1.04-.12 2.07-.05 3.1.1.62.09 1.24.21 1.87.33.91.18 1.83.38 2.75.54 1.31.22 2.63.37 3.96.34.07 0 .13.02.18.07l-.86-1.15c-.3 0-.59 0-.87-.05Zm-18.72 4.89c-.21-.39-.5-.73-.8-1.06a7.75 7.75 0 0 0-2.38-1.91 10.23 10.23 0 0 0-3.76-.95c-1.67-.13-3.32.05-4.97.34-1.17.21-2.32.48-3.5.68-1.44.24-2.88.38-4.34.37-.04 0-.09.02-.1-.02l-.01-.04-.91 1.15.14-.13c.1-.1.21-.14.35-.14.87 0 1.73.01 2.6-.03a47.6 47.6 0 0 0 3.16-.25c1-.12 1.99-.3 2.98-.45 1.1-.17 2.19-.3 3.3-.31 1.42-.01 2.83.11 4.2.54 1.13.34 2.13.92 2.98 1.73.21.2.38.44.55.68.05.07.08.12-.02.18l.9-.35a.85.85 0 0 0-.22.04c-.08.02-.12 0-.15-.07Zm0 0"
    />

<path
  fill={color}
  d="M17.8 43.84c.08-.05.3-.2.5-.2 1.28 0 2.54-.13 3.79-.36 1.15-.21 2.29-.48 3.45-.67.69-.11 1.38-.25 2.09-.29 1.34-.08 2.66.07 3.96.42 1.29.35 2.42.95 3.45 1.77l.7.58c-.12-.25-.3-.45-.46-.67a8.2 8.2 0 0 0-2.48-2.22 9.07 9.07 0 0 0-4.18-1.1 14.2 14.2 0 0 0-3.12.26c-1.22.21-2.42.53-3.64.78-.9.18-1.8.36-2.72.4 0 0-1.71 1.55-1.34 1.3Zm0 0"
/>

<g clipPath="url(#clip1)">
  <path
    fill={color}
    d="M44.43 26.32c-2.68-.08-4.79 1.97-5.9 4.23l-.04-.01c-1.07-3.17-3.67-6.26-7.16-6.66-.04.07-.08.07-.12 0-5.73-.14-5.34 5.66-2.56 9.07 2.55 3.8 7.24 6.17 8.15 10.94.38.37.66-.7.66-.99.37-2.8-1.95-4.97-3.62-6.85-1.75-1.83-3.58-3.68-4.73-5.96-1.06-2.23-1.61-5.5 1.89-5.16 3.66.47 7.04 3.94 7.04 7.68.3.08.6.02.63-.35.16-1.23.92-2.3 1.7-3.22 1.95-2.4 5.94-2.83 6.32.9.15 4.61-4.35 7.9-8.08 9.79v.03c1.53.25 3.4-1.3 4.66-2.1 2.65-1.93 5.12-5.15 4.66-8.5a3.68 3.68 0 0 0-3.5-2.83Zm0 0"
  />
</g>

<g mask="url(#mask0)">
  <g clipPath="url(#clip3)" transform="translate(37 43)">
    <g clipPath="url(#clip2)">
      <path
        fill={color}
        d="M1.68 4.68a6.8 6.8 0 0 1 2.62-2.12c1.03-.46 2.1-.74 3.22-.84 1.25-.13 2.5-.08 3.75.05 1.4.14 2.8.4 4.2.6 1.1.16 2.21.25 3.33.29.92.04 1.85.05 2.77.04.22 0 .38.04.54.2l-.67-.95s-.05-.07-.19-.07l-.24-.02c-.96.05-1.9-.05-2.86-.16-1.45-.18-2.9-.47-4.33-.76A23.5 23.5 0 0 0 10.73.5a14.6 14.6 0 0 0-4.42.27c-.76.18-1.5.44-2.18.82-.6.34-1.14.77-1.63 1.26-.45.46-.9.94-1.22 1.5-.07.13-.14.15-.26.13l.7.34c-.07-.04-.1-.07-.04-.14Zm0 0"
      />
    </g>
  </g>
</g>

<g mask="url(#mask1)">
  <g clipPath="url(#clip5)" transform="translate(15 43)">
    <g clipPath="url(#clip4)">
      <path
        fill={color}
        d="M21.64 4.41c-.21-.39-.5-.73-.8-1.06a7.75 7.75 0 0 0-2.38-1.91A10.23 10.23 0 0 0 14.7.49c-1.67-.13-3.32.05-4.97.34-1.17.21-2.32.48-3.5.68-1.44.24-2.88.38-4.34.37-.04 0-.09.02-.1-.02l-.01-.04-.91 1.15.14-.13c.1-.1.21-.14.35-.14.87 0 1.73.01 2.6-.03a47.6 47.6 0 0 0 3.16-.25c1-.12 1.99-.3 2.98-.45 1.1-.17 2.19-.3 3.3-.31 1.42-.01 2.83.11 4.2.54 1.13.34 2.13.92 2.98 1.73.21.2.38.44.55.68.05.07.08.12-.02.18l.9-.35a.85.85 0 0 0-.22.04c-.08.02-.12 0-.15-.07Zm0 0"
      />
    </g>
  </g>
</g>

<g clipPath="url(#clip6)">
  <path
    fill={color}
    d="M62.88 48.33c-.5-.45-.94-.97-1.43-1.44-.68-.68-1.38-1.33-2.08-2l-2.26-2.17a.58.58 0 0 0-.47-.17h-.41s2.72 3.93 3.07 4.25a49.83 49.83 0 0 1-7.47-.25c-1.08-.13-2.15-.3-3.22-.44-1.2-.17-2.42-.21-3.63-.12-1.22.1-2.42.34-3.48.98-.73.43-1.37 1-1.87 1.7-.02.03-.03.1-.1.1s-.06-.07-.08-.11c-.3-.57-.29-.9-1.34-1.27a2.26 2.26 0 0 0-2.72 1.23c-.05.1-.09.13-.16.01-.22-.34-.5-.63-.82-.88-.39-.31-.74-.68-1.2-.9a8.61 8.61 0 0 0-2.54-.77 15.51 15.51 0 0 0-3.1-.1c-1 .06-2 .2-3 .35-1.26.2-2.53.37-3.8.44-1.76.1-3.52.12-5.28.06-.17 0-.03.01-.22-.03.14-.13 3.87-4.26 3.87-4.26-.24.01-.5.02-.74.01-.2 0-.35.1-.49.23l-2.2 2.07c-.99.96-2.02 1.88-2.96 2.89l-.71.72h.09c1.33 0 2.65.09 3.98.09.36 0 .74-.01 1.1.05.37.08.73.12 1.1.1.78-.06 1.57-.04 2.34 0 2.17.07 4.35.12 6.52.13 1.53.01 3.06 0 4.58.12.5.03.98.09 1.44.27.41.17.71.48.97.82.36.5.8.83 1.4 1.01.34.1.62.21 1 .06.38-.18.83-.09 1.26-.09.52 0 1.05.02 1.58 0 .38-.02.74-.14 1-.45.19-.21.37-.43.54-.66.35-.46.8-.73 1.38-.83.91-.15 1.84-.2 2.77-.22 2.02-.05 4.05-.06 6.07-.13 1.9-.07 3.8-.11 5.7-.16l5.96-.11c.04 0 .1.03.12-.03.01-.04-.03-.07-.06-.1Zm0 0"
  />
</g>

    
  </svg>
);

export default Avatar3;
